"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerVendorCreate = exports.HaulerVendorTransport = exports.HaulerVendorReferenceTransport = exports.HaulerVendorReferenceTypeSchema = exports.HaulerVendorReferenceTypes = exports.HaulerVendorStatusLabels = exports.HaulerVendorStatusSchema = exports.HaulerVendorStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.HaulerVendorStatuses = [
    'NOT_STARTED',
    'IN_PROGRESS',
    'ACTIVE',
    'PAUSED',
    'SUSPENDED',
    'BANNED',
    'DRAFT',
    'BROKER',
];
exports.HaulerVendorStatusSchema = typebox_1.Type.Union(exports.HaulerVendorStatuses.map((s) => typebox_1.Type.Literal(s)));
exports.HaulerVendorStatusLabels = {
    NOT_STARTED: 'Prospect',
    IN_PROGRESS: 'Onboarding',
    ACTIVE: 'Active',
    PAUSED: 'Paused',
    SUSPENDED: 'Suspended',
    BANNED: 'Banned',
    DRAFT: 'Draft',
    BROKER: 'Broker',
};
exports.HaulerVendorReferenceTypes = ['AR_ACCOUNT', 'AR_LINE_ITEM'];
exports.HaulerVendorReferenceTypeSchema = typebox_1.Type.Union(exports.HaulerVendorReferenceTypes.map((type) => typebox_1.Type.Literal(type)));
exports.HaulerVendorReferenceTransport = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })), //ignored on create
    name: typebox_1.Type.String(),
    haulerVendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })), //ignored on create
    referenceType: exports.HaulerVendorReferenceTypeSchema,
    referenceValue: typebox_1.Type.String(),
    metadata: typebox_1.Type.Optional(common_1.MetaData),
});
exports.HaulerVendorTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    references: typebox_1.Type.Array(exports.HaulerVendorReferenceTransport),
    metadata: typebox_1.Type.Optional(common_1.MetaData),
});
exports.HaulerVendorCreate = typebox_1.Type.Omit(exports.HaulerVendorTransport, ['id', 'metadata', 'haulerID']);
//# sourceMappingURL=hauler-vendor.js.map